import { combineReducers, Reducer } from 'redux';

import advertising from './advertising';
import comments from './comments';
import likes from './likes';
import locations from './locations';
import metadata from './metadata';
import news from './news';
import organizations from './organizations';
import phoneConfirmation from './phoneConfirmation';
import search from './search';
import sitesettings from './sitesettings';
import smsCodeStatus from './smsCodeStatus';
import specialOffers from './specialOffers';
import survey from './survey';
import user from './user';
import whitelabel from './whitelabel';
import widget from './widget';

export interface IGlobalState {
  sitesettings: ReturnType<typeof sitesettings>;
  metadata: ReturnType<typeof metadata>;
  user: ReturnType<typeof user>;
  locations: ReturnType<typeof locations>;
  news: ReturnType<typeof news>;
  advertising: ReturnType<typeof advertising>;
  whitelabel: ReturnType<typeof whitelabel>;
  widget: ReturnType<typeof widget>;
  survey: ReturnType<typeof survey>;
  comments: ReturnType<typeof comments>;
  likes: ReturnType<typeof likes>;
  organizations: ReturnType<typeof organizations>;
  specialOffers: ReturnType<typeof specialOffers>;
  phoneConfirmation: ReturnType<typeof phoneConfirmation>;
  smsCodeStatus: ReturnType<typeof smsCodeStatus>;
  search: ReturnType<typeof search>;
}

const reducer: Reducer<IGlobalState> = combineReducers<IGlobalState>({
  sitesettings,
  metadata,
  user,
  locations,
  news,
  advertising,
  whitelabel,
  widget,
  survey,
  comments,
  likes,
  organizations,
  specialOffers,
  phoneConfirmation,
  smsCodeStatus,
  search,
});

export default reducer;
